// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__15EP9","containerItemsCenter":"Skeleton_containerItemsCenter__1N-5G"};